export const recordPerPage = 20;
export const messageKeyPrefix = 'org.wifi.indigo.api.';
export const healthCheckTimout = {
  onRequest: 8000,
  onFail: 60000,
};
